import React, { useState } from "react";
const PollutantEmissionTable = ({
  pollutantEmissionTable,
  setPollutantEmissionTable,
}) => {
  const handleInputChange = (rowIndex, value) => {
    const updatedData = [...pollutantEmissionTable];
    updatedData[rowIndex].Emission = value;
    setPollutantEmissionTable(updatedData);
    console.log(updatedData, "passed data");
  };

  return (
    <div>
      {/* Table Container */}
      <div
        style={{
          marginTop: "20px",
          border: "1px solid #000",
          borderRadius: "8px",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr
              style={{
                backgroundColor: "#D3C9CE",
                color: "#000",
                fontWeight: "bold",
                textAlign: "left",
              }}
            >
              <th style={tableHeaderStyle}>Pollutant</th>
              <th style={tableHeaderStyle}>Emission (metric tons)</th>
            </tr>
          </thead>
          <tbody>
            {(pollutantEmissionTable || []).map((row, index) => (
              <tr key={index}>
                <td
                  style={{
                    ...tableCellStyle,
                    backgroundColor: "#f5f5f5",
                    fontWeight: "bold",
                  }}
                >
                  {row.Pollutant}
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="number"
                    value={row.Emission}
                    onChange={(e) => handleInputChange(index, e.target.value)}
                    style={inputFieldStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputFieldStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default PollutantEmissionTable;
